var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    ref: "searchFieldValidator",
    staticClass: "search-component-wrapper",
    attrs: { rules: _vm.validationRules, name: "searchField", tag: "div" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c("div", { staticClass: "search-wrapper" }, [
              _c(
                "div",
                {
                  class: [
                    { "error-styles": _vm.applyErrorStyles },
                    "search-field-container",
                  ],
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchTerm,
                        expression: "searchTerm",
                      },
                    ],
                    staticClass: "search-field",
                    attrs: { type: "text", placeholder: _vm.placeholder },
                    domProps: { value: _vm.searchTerm },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchOrClearTerm.apply(null, arguments)
                      },
                      change: _vm.onlyForMobile,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.searchTerm = $event.target.value
                      },
                    },
                  }),
                  _vm.searchTerm
                    ? _c("span", {
                        staticClass: "clear-icon lf-icon-close",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.clearSearch.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                  _c("span", {
                    staticClass: "search-icon",
                    class: _vm.searchIconType,
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.searchOrClearTerm.apply(null, arguments)
                      },
                    },
                  }),
                ]
              ),
            ]),
            _vm.showErrors
              ? _c("div", { staticClass: "messages-container" }, [
                  _c("span", { staticClass: "alert-message" }, [
                    _vm._v(_vm._s(errors[0])),
                  ]),
                ])
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }